<template>
  <div class="card mb-3">
    <div class="card-header" :id="'heading' + index">
      <div class="mb-0">
        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true"
                :aria-controls="'collapse' + index">Automobile Insurance</button>
        <button class="btn mt-1 font-size-small text-color-grey float-right">{{ dateCreated }}</button>
      </div>
    </div>
    <div :id="'collapse' + index" class="collapse" :aria-labelledby="'headingFour' + index" data-parent="#accordion">
      <div class="card-body d-md-flex flex-md-wrap">
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Name : </span>
          <span>{{ data.name }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Address : </span>
          <span>{{ data.address }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Country : </span>
          <span>{{ data.country }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Zip Code : </span>
          <span>{{ data.zipcode }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Phone Number : </span>
          <span>{{ data.phonenumber }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Email : </span>
          <span>{{ data.email }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Marital Status : </span>
          <span>{{ data.maritalstatus }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Gender : </span>
          <span>{{ data.gender }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Date of Birth : </span>
          <span>{{ data.datebirth }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Date of licence : </span>
          <span>{{ data.datelicenced }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Licence Number : </span>
          <span>{{ data.licencenumber }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Vehicle Number : </span>
          <span>{{ data.vehiclenumber }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Year : </span>
          <span>{{ data.year }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Make : </span>
          <span>{{ data.make }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Model : </span>
          <span>{{ data.model }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Annual Mileage : </span>
          <span>{{ data.annualmillage }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Usage : </span>
          <span>{{ data.usage }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceViewAuto',
  // Load props received from parent component to display insurance data
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  // convert date to a string using local settings
  data () {
    return {
      dateCreated: null
    }
  },
  created () {
    let date = new Date(this.data.created_on)
    this.dateCreated = date.toLocaleString()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/views/InsuranceViewAuto.vue